import { IconWithText } from 'common/icon/icon-with-text.js';
import { MarkerTypeWaterActivity } from 'types/markerTypes/location-markers-type.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { predicateNumber } from 'utilities/isType.js';
import { MarkerComponentType } from './utils.js';

export type MarineConditionsItem = {
  key: MarkerComponentType.Marine;
  index: string;
  swell: number;
};

export const hasMarineConditions = ({ value, label, type }: ILocationSummary): MarineConditionsItem | undefined => {
  if (type === MarkerTypeWaterActivity.Boating || type === MarkerTypeWaterActivity.Surfing) {
    const seaHeight = value.swell?.seaHeight;
    const hasSwell = predicateNumber(seaHeight);
    if (hasSwell) {
      return {
        key: MarkerComponentType.Marine,
        index: `${type}-${label}`,
        swell: seaHeight,
      };
    }
  }
  return undefined;
};

export const MarineConditions = ({ swell }: MarineConditionsItem) => {
  return (
    <IconWithText
      icon="swell"
      classes="IconWithText--vCenter IconWithText--small IconWithText--inline u-mL-xs svg-fill-textSlate"
      contentClass="u-textRegular"
      iconClass="svg-fill-textSlate"
    >
      {swell}m
    </IconWithText>
  );
};
